import { render, staticRenderFns } from "./manageBatch.vue?vue&type=template&id=79787184&"
import script from "./manageBatch.vue?vue&type=script&lang=js&"
export * from "./manageBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports